module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel-suns_access_01-3e3465a398ee10ee1ec411b077aabafd.jpg";